/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { CabinetContext } from '../../../../context/CabinetContext';
import { Form, Input } from 'antd';
import { useLazyQuery } from '@apollo/client';
import { GET_CABINET_PARAM, TCabinetEntityParamData, TCabinetInfo, TGetCabinetDataInput, TGetCabinetParamDataOutput } from '../../../../graphql/schema';
import { FAKE_CABINET_ADDRESS, FAKE_CABINET_ENTITIES, FAKE_CABINET_IDENTIFIER, FAKE_CABINET_PE_NUMBER } from '../../../../common/constants';

interface IInfoDetailProps {
}

const InfoDetail: React.FunctionComponent<IInfoDetailProps> = (props) => {
    const { selectedDevice } = React.useContext(CabinetContext)!
    const [entityId, setEntityId] = React.useState<string>()
    const [formParam] = Form.useForm<TCabinetEntityParamData>();
    const [formInfo] = Form.useForm<TCabinetInfo>();
    const [getCabinetParam] = useLazyQuery<TGetCabinetParamDataOutput, TGetCabinetDataInput>(GET_CABINET_PARAM, {
        fetchPolicy: 'network-only',
    });

    const getData = async () => {
        const returnData = await getCabinetParam({
            variables: {
                cabinetDeviceId: selectedDevice!.id
            }
        });
        const result = returnData.data?.getCabinetParamData;
        if (!result) return
        formInfo.setFieldsValue({
            address: FAKE_CABINET_ADDRESS,
            identifier: FAKE_CABINET_IDENTIFIER + result.deviceId,
            PENumber: FAKE_CABINET_PE_NUMBER,
        });
        formParam.setFieldsValue({
            ...result,
            location: result.lat && result.lng ? `${result.lat}, ${result.lng}` : 'N/A',
        } as any);
        setEntityId(FAKE_CABINET_IDENTIFIER)
    }
    React.useEffect(() => {
        getData()
    }, [])
    return <>
        <Form
            form={formInfo}
            name="basic"
            wrapperCol={{ span: 24 }}
            className="grid grid-cols-6 gap-2 max-w-[600px] mt-2"
            autoComplete="off"
        >
            <Form.Item className="col-span-10 h-[8px] w-full" label="Mã thiết bị" name="identifier">
                <Input className="w-full" readOnly />
            </Form.Item>
            <Form.Item className="col-span-10 h-[8px] w-full" label="Mã tủ" name="PENumber">
                <Input className="w-full" readOnly />
            </Form.Item>
            <Form.Item className="col-span-10 h-[8px]" label="Địa chỉ" name="address">
                <Input className="w-full" readOnly />
            </Form.Item>

            {/* <Form.Item
                className="col-span-3"
                label="Quận/Huyện"
                name="district"
            >
                <Input className="w-full" readOnly />
            </Form.Item>
            <Form.Item className="col-span-3" label="Tỉnh" name="province">
                <Input className="w-full" readOnly />
            </Form.Item>
            <Form.Item
                className="col-span-3"
                label="Trạng thái mạng"
                name="isConnected"
            >
                <Input
                    className={`w-full ${errors.notconnect && "bg-variant-error"
                        }`}
                    readOnly
                />
            </Form.Item>
            <Form.Item className="col-span-3" label="Loại PM" name="pmkind">
                <Input className="w-full" readOnly />
            </Form.Item>
            <Form.Item className="col-span-2" label="PLC" name="plc_connect">
                <Input
                    className={`w-full ${errors.plc && "bg-variant-error"}`}
                    readOnly
                />
            </Form.Item>
            <Form.Item className="col-span-2" label="LC" name="lc_connect">
                <Input
                    className={`w-full ${errors.lc && "bg-variant-error"}`}
                    readOnly
                />
            </Form.Item>
            <Form.Item className="col-span-2" label="PM" name="pm_connect">
                <Input
                    className={`w-full ${errors.pm && "bg-variant-error"}`}
                    readOnly
                />
            </Form.Item> */}

            
            {/* <div className="col-span-3">Hình ảnh:</div>
              <Form.Item
                className="col-span-3"
                valuePropName="src"
                name="image_src"
              >
                <Image
                  alt="Ảnh tủ"
                  width="100%"
                  fallback="data:image/png;base64,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"
                />
              </Form.Item> */}
            
        </Form>
        <Form
            form={formParam}
            name="basic"
            wrapperCol={{ span: 24 }}
            className="grid grid-cols-6 gap-2 max-w-[600px] mt-2"
            autoComplete="off"
        >
            <Form.Item
                className="col-span-6 h-[8px]"
                label="Firmware"
                name="fwVersion"
            >
                <Input className="w-full" readOnly />
            </Form.Item>
            <Form.Item
                className="col-span-6 h-[8px]"
                label="Hardware"
                name="hwVersion"
            >
                <Input className="w-full" readOnly />
            </Form.Item>
            <div className="col-span-6 flex gap-2 items-end">
                <Form.Item
                    className="w-full h-[8px]"
                    label="Tọa độ GPS"
                    name="location"
                >
                    <Input className="w-full" readOnly />
                </Form.Item>
                {/* <Button
                    title="Đồng bộ tọa độ cho tủ"
                    disabled={!validLocation}
                    icon={<SyncOutlined />}
                    onClick={handleSyncLocation}
                ></Button> */}
            </div>
            <Form.Item
                className="col-span-6 h-[8px]"
                label="imei"
                name="imei"
            >
                <Input className="w-full" readOnly />
            </Form.Item>
            <Form.Item
                className="col-span-6 h-[8px]"
                label="rssi"
                name="rssi"
            >
                <Input className="w-full" readOnly />
            </Form.Item>
            <Form.Item
                className="col-span-6 h-[8px]"
                label="netProvider"
                name="netProvider"
            >
                <Input className="w-full" readOnly />
            </Form.Item>
            <Form.Item
                className="col-span-6 h-[8px]"
                label="netGen"
                name="netGen"
            >
                <Input className="w-full" readOnly />
            </Form.Item>
            {/* {userInfo && userInfo.user.roleId === eUserRole.SUPPERADMIN && (
                <>
                    <Form.Item
                        className="col-span-6"
                        label="Dữ liệu thô"
                        name="rawData"
                    >
                        <TextArea className="w-full" readOnly />
                    </Form.Item>
                </>
            )} */}
        </Form>
    </>;
};

export default InfoDetail;
